import { render, staticRenderFns } from "./RevisionTitle.vue?vue&type=template&id=48f616f6&"
import script from "./RevisionTitle.vue?vue&type=script&lang=ts&"
export * from "./RevisionTitle.vue?vue&type=script&lang=ts&"
import style0 from "./RevisionTitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports